import { Login, Logo } from '@firmable/icons';
import React from 'react';

type LayoutProps = {
  children: React.ReactNode;
};

export const UserOnboardingLayout = ({ children }: LayoutProps) => {
  return (
    <div className="relative flex flex-col w-full min-h-screen pt-16">
      <div className="flex items-center gap-3 w-full mb-10">
        <Logo.Light.FirmableIcon width={36} height={36} />
        <Logo.Light.FirmableFullWhite width={126} height={36} />
      </div>
      {children}
      <div className="relative mt-auto overflow-visible pt-14 min-h-[350px]">
        <div className="absolute bottom-0 left-[-62px]">
          <Login.ProductExample />
        </div>
      </div>
    </div>
  );
};
